import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  bcSpaced: {
    display: "flex",
    alignItems: "center",
    minHeight: 36,
  },
  title: {
    fontSize: 36,
    lineHeight: "54px",
    marginBottom: 24,
    display: "inline-flex",
    alignItems: "center"
  },
}));

export default useStyles;